module.exports = __webpack_public_path__ + "img/stickers-attestation-fiscale.64048255.jpg";